import $ from 'jquery'
import React, { Component } from 'react'

type Props = {|
  id: string,
  browseText: string,
  validExtensions: Array<string>,
  wrongExtensionText: string,
  onSuccessChange: Function
|}

type State = {|
  isCorrect: boolean,
  infoText: string
|}

export default class FileUploadComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { isCorrect: true, infoText: '' }
    this.fileChangedFn = (...args) => this.fileChanged(...args)
  }

  render() {
    return (
      <div className="btn btn-default btn-file">
        <span className="browse">{this.props.browseText}...</span>
        <span className={this.state.isCorrect ? null : 'error_explanation'}>
          {this.state.infoText}
        </span>
        <input
          onChange={(e) => {
            this.fileChangedFn(e)
          }}
          type="file"
          id={this.props.id}
          accept=".txt"
        />
      </div>
    )
  }

  fileChanged(e) {
    let fileElement = e.target
    let file = $(fileElement)
    let fileName = file.val()

    if (!fileName) return

    let formattedFilename = fileName.replace(/.*[\\/]/, '')

    let isCorrect = this.checkFormat(fileName)

    let infoText = formattedFilename + (isCorrect ? '' : ' ' + this.props.wrongExtensionText)

    if (!isCorrect) file.val('')

    this.setState({ isCorrect, infoText })

    if (isCorrect && this.props.onSuccessChange) {
      this.props.onSuccessChange(fileElement)
    }
  }

  checkFormat(name) {
    if (this.props.validExtensions.length > 0) {
      let ext = name.substring(name.lastIndexOf('.'))
      return this.props.validExtensions.indexOf(ext) >= 0
    } else {
      return true
    }
  }
}
